"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLocalYmlGenerator = exports.AppLocalYmlConfig = void 0;
const appYmlGenerator_1 = require("../appYmlGenerator");
const debugV3MigrationUtils_1 = require("./debugV3MigrationUtils");
class AppLocalYmlConfig {
    provision = {};
    deploy;
}
exports.AppLocalYmlConfig = AppLocalYmlConfig;
class AppLocalYmlGenerator extends appYmlGenerator_1.BaseAppYmlGenerator {
    handlebarsContext;
    constructor(oldProjectSettings, config, placeholderMappings) {
        super(oldProjectSettings);
        this.handlebarsContext = {
            config: config,
            placeholderMappings: placeholderMappings,
        };
    }
    async generateAppYml() {
        await this.generateHandlerbarsContext();
        switch (this.oldProjectSettings.programmingLanguage?.toLowerCase()) {
            case "javascript":
            case "typescript":
            default:
                // only support js/ts at first
                return await this.buildHandlebarsTemplate("js.ts.app.local.yml");
        }
    }
    generateHandlerbarsContext() {
        let functionName = undefined;
        if (debugV3MigrationUtils_1.OldProjectSettingsHelper.includeFunction(this.oldProjectSettings)) {
            functionName =
                debugV3MigrationUtils_1.OldProjectSettingsHelper.getFunctionName(this.oldProjectSettings) || "getUserProfile";
        }
        if (this.handlebarsContext.config.provision?.configureApp) {
            this.handlebarsContext.config.provision.configureApp.isM365 = this.oldProjectSettings.isM365;
        }
        if (this.handlebarsContext.config.provision?.bot) {
            this.handlebarsContext.config.provision.bot.isM365 = this.oldProjectSettings.isM365;
        }
        if (this.handlebarsContext.config.deploy?.sso) {
            if (debugV3MigrationUtils_1.OldProjectSettingsHelper.includeTab(this.oldProjectSettings)) {
                this.handlebarsContext.config.deploy.ssoTab = {
                    functionName,
                };
            }
            if (debugV3MigrationUtils_1.OldProjectSettingsHelper.includeBot(this.oldProjectSettings)) {
                this.handlebarsContext.config.deploy.ssoBot = true;
            }
            if (functionName) {
                this.handlebarsContext.config.deploy.ssoFunction = true;
            }
        }
        return Promise.resolve();
    }
}
exports.AppLocalYmlGenerator = AppLocalYmlGenerator;
//# sourceMappingURL=appLocalYmlGenerator.js.map